var _linearGradient, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 130 142.7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 168.37,
    x2: 289.96,
    y1: 199.9,
    y2: 199.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1562b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#f1542b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#f04d2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#ef4229"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ef4029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e83e28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#e13c26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#df3c26"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-168.37 -128.55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m290 174.71-4.4-11.95 3.06-6.86a2.35 2.35 0 0 0 -.48-2.61l-8.32-8.41a13.43 13.43 0 0 0 -14-3.25l-2.33.81-12.71-13.77-21.56-.12h-.14l-21.7.17-12.7 13.88-2.26-.8a13.47 13.47 0 0 0 -14.09 3.28l-8.47 8.57a1.87 1.87 0 0 0 -.38 2.08l3.19 7.12-4.38 11.94 2.83 10.77 12.91 49.08a25 25 0 0 0 9.67 14s15.67 11.05 31.13 21.09a6.9 6.9 0 0 0 8.61 0c17.37-11.38 31.11-21.13 31.11-21.13a25 25 0 0 0 9.66-14l12.84-49.1z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m232.72 217a18.42 18.42 0 0 0 -2.54-.92h-1.53a18.42 18.42 0 0 0 -2.54.92l-3.85 1.6c-1.22.51-3.18 1.42-4.35 2l-7.08 3.69a1.35 1.35 0 0 0 -.17 2.5l6.15 4.34c1.08.76 2.78 2.1 3.78 3l1.73 1.49c1 .86 2.63 2.29 3.62 3.17l1.64 1.45a2.82 2.82 0 0 0 3.61 0l1.72-1.5 3.62-3.16 1.74-1.52c1-.87 2.69-2.21 3.77-3l6.15-4.4a1.34 1.34 0 0 0 -.19-2.49l-7.07-3.59c-1.18-.6-3.14-1.5-4.37-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.32 177.38.2-.64a16.84 16.84 0 0 0 -.16-2.56 21.57 21.57 0 0 0 -2.28-4.3l-4-5.87c-.74-1.1-2-2.84-2.85-3.87l-5.36-6.71a18.74 18.74 0 0 0 -1.59-1.86h-.11s-1.08.19-2.38.44l-8.19 1.58-3.59.69a9.33 9.33 0 0 1 -3.51-.51l-6.47-2.09c-1.26-.41-3.34-1-4.63-1.28a19.35 19.35 0 0 0 -4.09 0c-1.29.3-3.37.88-4.63 1.29l-6.47 2.1a9.33 9.33 0 0 1 -3.51.51l-3.59-.68-8.2-1.57c-1.3-.25-2.37-.45-2.38-.44h-.11a18.74 18.74 0 0 0 -1.59 1.86l-5.35 6.71c-.82 1-2.11 2.78-2.85 3.87l-4 5.87a31.45 31.45 0 0 0 -1.89 3.15 14.32 14.32 0 0 0 -.54 3.72l.2.64a9.49 9.49 0 0 0 .37 1.21c.83 1 2.25 2.66 3.16 3.63l14 14.88a4 4 0 0 1 .71 4l-2.29 5.43a7.05 7.05 0 0 0 -.11 4.47l.46 1.26a12.15 12.15 0 0 0 3.73 5.23l2.2 1.79a4.16 4.16 0 0 0 4 .48l7.82-3.73a19.88 19.88 0 0 0 4-2.65l6.26-5.65a2.51 2.51 0 0 0 .13-3.6l-14.13-9.52a2.74 2.74 0 0 1 -.86-3.47l5.48-10.3a5.35 5.35 0 0 0 .27-4.09 6.25 6.25 0 0 0 -3.11-2.82l-17.18-6.49c-1.24-.47-1.17-1 .14-1.08l10.09-1a15.57 15.57 0 0 1 4.71.42l8.78 2.45a2.69 2.69 0 0 1 1.88 3l-3.45 18.84a9.74 9.74 0 0 0 -.17 3.18c.14.45 1.32 1 2.61 1.32l5.35 1.14a13 13 0 0 0 4.7 0l4.81-1.09c1.29-.29 2.46-.9 2.61-1.35a9.73 9.73 0 0 0 -.18-3.18l-3.47-18.84a2.69 2.69 0 0 1 1.88-3l8.78-2.46a15.56 15.56 0 0 1 4.71-.42l10.09.94c1.32.12 1.38.61.15 1.08l-17.17 6.51a6.25 6.25 0 0 0 -3.11 2.82 5.36 5.36 0 0 0 .27 4.09l5.49 10.3a2.74 2.74 0 0 1 -.86 3.47l-14.12 9.54a2.51 2.51 0 0 0 .13 3.6l6.27 5.65a19.88 19.88 0 0 0 4 2.64l7.82 3.72a4.16 4.16 0 0 0 4-.49l2.2-1.8a12.14 12.14 0 0 0 3.73-5.24l.46-1.26a7.05 7.05 0 0 0 -.11-4.47l-2.3-5.43a4 4 0 0 1 .71-4l14-14.9c.91-1 2.32-2.6 3.15-3.63a9.49 9.49 0 0 0 .43-1.18z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrave);
export default __webpack_public_path__ + "static/media/brave.ed521304d8e517d3fa8481ded8829f65.svg";
export { ForwardRef as ReactComponent };